<template>
  <div class="svg-button" :class="{active: active}" @click="$emit('action', $event)">
    <slot />
  </div>
</template>

<script>
  export default {
    name: "SvgButton",
    props: {
      active: Boolean,
    }
  }
</script>

<style lang="scss">
.svg-button {
  position: relative;
  pointer-events: auto;
  overflow: hidden;
  cursor: pointer;
  isolation: isolate;

  min-width: 42px;
  min-height: 42px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.10);

  background: linear-gradient(180deg, rgba(255, 255, 255, 0.075), rgba(255, 255, 255, 0.035));
  color: var(--im-text, var(--theme-fg));

  transition: transform 0.18s ease, border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;

  &::before {
    content: "";
    position: absolute;
    inset: -1px;
    z-index: -1;
    opacity: 0;
    border-radius: inherit;
    background: radial-gradient(circle at 50% 0%, rgba(67, 217, 255, 0.24), transparent 68%);
    transition: opacity 0.18s ease;
  }

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(67, 217, 255, 0.34);
    background: rgba(67, 217, 255, 0.10);
    box-shadow: 0 10px 26px rgba(0, 0, 0, 0.22);

    &::before { opacity: 1; }
  }

  &.active,
  &.close,
  &:active {
    border-color: rgba(55, 242, 154, 0.40);
    background: linear-gradient(135deg, rgba(55, 242, 154, 0.22), rgba(67, 217, 255, 0.16));
    color: var(--im-text, var(--theme-fg));
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06), 0 0 24px rgba(55, 242, 154, 0.12);
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    height: 1.55em;

    fill: var(--im-muted, var(--theme-fg-light));
    transition: fill 0.18s ease, filter 0.18s ease;
  }

  &:hover svg,
  &.active svg,
  &.close svg,
  &:active svg {
    fill: var(--im-text, var(--theme-fg));
    filter: drop-shadow(0 0 10px rgba(67, 217, 255, 0.28));
  }
}
</style>